










import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { GroupBuyingComponents } from '@/views/group_buying/components'

export default defineClassComponent(
  {
    components: GroupBuyingComponents,
  },
  () =>
    class {
      // 商品数据
      bookGoodsModel = bookGoodsModelProvider.inject()

      // 倒计时结束
      handleCountdownEnd = () => {
        this.bookGoodsModel.value.refreshMarketing()
      }
    },
)
